import React from 'react';
import Button from '@material-ui/core/Button';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Analysis extends React.Component {

  state = {
    out: []
  }

  analysis() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    context.setState({ load: true, message: 'Getting Parts!!!!' });
    $.ajax({
      method: 'POST',
      data: { 'branch_id': branch_id},
      url: Server() + 'analytics/get.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ out: data, open: true })
        } catch (e) {
        }
        context.setState({ load: false });
      },
      error: function(error) {
        alert('Try Again!!!');
        context.setState({ load: false });
      }
    })
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button color='primary' variant='outlined' onClick={this.analysis.bind(this)}>Analysis</Button>
        <Dialog open={this.state.open} onClose={ () => { this.setState({ open: false }) }}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 600}}>
            {"Analysis"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {
                this.state.out.map((v) => {
                  return(
                    <table width='100%' id='table'>
                      <tr id='tablehead'>
                        <th style={{color: 'white'}}></th>
                        <th style={{color: 'white'}}>Today</th>
                        <th style={{color: 'white'}}>7 Days</th>
                        <th style={{color: 'white'}}>30 Days</th>
                        <th style={{color: 'white'}}>60 Days</th>
                        <th style={{color: 'white'}}>90 Days</th>
                      </tr>
                      <tr>
                        <td>Prior Order</td>
                        <td>{v.priororderoftoday? v.priororderoftoday:'0'}</td>
                        <td>{v.priororderoflast7day? v.priororderoflast7day:'0'}</td>
                        <td>{v.priororderoflast30day? v.priororderoflast30day:'0'}</td>
                        <td>{v.priororderoflast60day? v.priororderoflast60day:'0'}</td>
                        <td>{v.priororderoflast90day? v.priororderoflast90day:'0'}</td>
                      </tr>
                      <tr>
                        <td>Waiting</td>
                        <td>{v.waitingoftoday? v.waitingoftoday:'0'}</td>
                        <td>{v.waitingoflast7day? v.waitingoflast7day:'0'}</td>
                        <td>{v.waitingoflast30day? v.waitingoflast30day:'0'}</td>
                        <td>{v.waitingoflast60day? v.waitingoflast60day:'0'}</td>
                        <td>{v.waitingoflast90day? v.waitingoflast90day:'0'}</td>
                      </tr>
                      <tr>
                        <td>Approved</td>
                        <td>{v.approvedoftoday? v.approvedoftoday:'0'}</td>
                        <td>{v.approvedoflast7day? v.approvedoflast7day:'0'}</td>
                        <td>{v.approvedoflast30day? v.approvedoflast30day:'0'}</td>
                        <td>{v.approvedoflast60day? v.approvedoflast60day:'0'}</td>
                        <td>{v.approvedoflast90day? v.approvedoflast90day:'0'}</td>
                      </tr>
                      <tr>
                        <td>Delivered</td>
                        <td>{v.deliveredoftoday? v.deliveredoftoday:'0'}</td>
                        <td>{v.deliveredoflast7days? v.deliveredoflast7days:'0'}</td>
                        <td>{v.deliveredoflast30days? v.deliveredoflast30days:'0'}</td>
                        <td>{v.deliveredoflast60days? v.deliveredoflast60days:'0'}</td>
                        <td>{v.deliveredoflast90days? v.deliveredoflast90days:'0'}</td>
                      </tr>
                      <tr>
                        <td>Executive Created</td>
                        <td>{v.executedbyoftoday? v.executedbyoftoday:'0'}</td>
                        <td>{v.executedbyoflast7day? v.executedbyoflast7day:'0'}</td>
                        <td>{v.executedbyoflast30day? v.executedbyoflast30day:'0'}</td>
                        <td>{v.executedbyoflast60day? v.executedbyoflast60day:'0'}</td>
                        <td>{v.executedbyoflast90day? v.executedbyoflast90day:'0'}</td>
                      </tr>
                      <tr>
                        <td>Customer Created</td>
                        <td>{v.createdbyoftoday? v.createdbyoftoday:'0'}</td>
                        <td>{v.createdbyoflast7day? v.createdbyoflast7day:'0'}</td>
                        <td>{v.createdbyoflast30day? v.createdbyoflast30day:'0'}</td>
                        <td>{v.createdbyoflast60day? v.createdbyoflast60day:'0'}</td>
                        <td>{v.createdbyoflast90day? v.createdbyoflast90day:'0'}</td>
                      </tr>
                    </table>
                  )
                })
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary" autoFocus>CLOSE</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Analysis;
